import { certiIcon, certificateBadge } from '../../../constants/icons';
import LinkWrapper from '../../LinkWrapper';

export default function AchievementsCounter(props) {
  const { title, certificateCounts, badge, className } = props;
  return (
    <div className={`myk__achievement-wrapper align-items-center  px-2 ${className || ''}`}>
      <div className="myk__achievement-holder">
        <div className="myk__achievement-logo">
          {badge || certificateBadge}
        </div>
        <div className="myk__achievement-info">
          <h2><strong>{certificateCounts}</strong> {title}</h2>
        </div>
      </div>
      {certificateCounts > 0 && <LinkWrapper className="btn btn-outline btn-sm btn-round" href="/student-dashboard/learner-profile" to="/" isReact={true}>{certiIcon} View all Certificates</LinkWrapper>}
    </div>
  );
}
